import { ExpertViewModel } from "../../model/ExpertViewModel";
import CustomSelect, { OptionType } from "../common/customSelect/CustomSelect";
import React from "react";
import { ActionMeta, ValueType } from "react-select/src/types";
import { GetTranslation } from "../../translations/GetTranslation";
import { IntlShape, useIntl } from "react-intl";
import { getExpertRoleTranslationKey } from "../../data/constants";

export type UserSelectProps = {
  availableUsers: ExpertViewModel[];
  selectedUsers: ExpertViewModel[];
  minimumSelectedUsers?: number;
  onUserSelectChange: (selectedElements: ValueType<OptionType>, actionMeta?: ActionMeta<OptionType>) => void;
  label?: JSX.Element;
  placeholder?: JSX.Element;
  name?: string;
};

const getOptions = (users: ExpertViewModel[], intl: IntlShape, withCity?: boolean): OptionType[] => {
  return users.map((user) => {
    return {
      label: `${user.firstName} ${user.lastName}${
        withCity && user.city && user.country ? ` - ${user.city} (${user.country})` : ""
      }`,
      value: user.id,
      tooltip: `${user.rolesWithExamsAndCourseTypes
        .map((re) => GetTranslation(intl, getExpertRoleTranslationKey(re.role)))
        .join(", ")} - ${user.languages.join(", ")}${
        user.city && user.country ? ` - ${user.city} (${user.country})` : ""
      }`,
    };
  });
};

const UserSelect: React.FunctionComponent<UserSelectProps> = ({
  availableUsers,
  minimumSelectedUsers,
  label,
  name,
  selectedUsers,
  placeholder,
  onUserSelectChange,
}) => {
  const intl = useIntl();
  return (
    <CustomSelect
      error={selectedUsers.length < minimumSelectedUsers!}
      xs={12}
      sm={12}
      md={12}
      required={false}
      value={getOptions(selectedUsers, intl)}
      name={name || ""}
      label={label}
      placeholder={placeholder}
      options={getOptions(availableUsers, intl, true)}
      isMulti={true}
      onChange={onUserSelectChange}
    />
  );
};

UserSelect.defaultProps = {
  name: "user-select-create",
  minimumSelectedUsers: 0,
} as Partial<UserSelectProps>;

export default UserSelect;
